/* eslint-disable import/no-unresolved */
import React, { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import * as getStatic from '@backpackjs/core-nextjs/get-static';
import { store } from '@backpackjs/storefront';

import ProductTemplate from '../../templates/product';
import { PageErrorBoundary, PageHead } from '../../_components';

export const getStaticPaths = getStatic.paths.product;
export const getStaticProps = getStatic.props.product;

function DraftBadge() {
  return (
    <p
      data-comp="DraftProductBadge"
      // eslint-disable-next-line react/no-unknown-property
      sx={{
        position: 'fixed',
        right: 0,
        top: 175,
        transform: 'rotate(-90deg)',
        transformOrigin: 'bottom right',
        backgroundColor: '#433d51',
        color: '#FFF',
        px: '20px',
        py: '10px',
        fontSize: '14px',
        letterSpacing: '4px',
        fontWeight: 200,
      }}
    >
      DRAFT
    </p>
  );
}

export default function Product({ isPreview, renderSections, ...props }) {
  const router = useRouter();
  const settingProduct = useRef(false);

  const { product } = props;

  const [recoilProduct, setProduct] = store.recoil.useRecoilState(
    store.state.product
  );

  const hasQueryParam = router.asPath.includes('?');
  const nextQueryParamReady = Object.keys(router.query).length > 1;
  const handlesMatch = product?.handle === recoilProduct?.handle;

  useEffect(() => {
    if (!handlesMatch) {
      // load the product onto the recoil state
      settingProduct.current = true;
      setProduct(product);
    } else {
      settingProduct.current = false;
    }

    return () => {
      if (hasQueryParam && !nextQueryParamReady) {
        // if we are processing query params
        return;
      }

      if (!settingProduct.current) {
        // unload the product onto the recoil state
        setProduct(null);
      }
    };
  }, [handlesMatch]);

  const productPage = props.page;

  return (
    <PageErrorBoundary>
      <PageHead page={productPage}>
        <>
          <ProductTemplate
            {...props}
            product={product}
            renderSections={renderSections}
          />

          {/* draft product badge */}
          {product?.publishedAt === null ? <DraftBadge /> : null}
        </>
      </PageHead>
    </PageErrorBoundary>
  );
}
